<template>
  <div class="white-section">
    <div class="d-flex mb-1 align-items-end">
      <b-card-body style="padding: 0" class="search-box d-flex justify-content-end">
        <b-row>
          <b-col xl="2"  md="3" cols="12" sm="12" class="mb-md-0">
            <label for="search" style="margin-top: 9px">جستجو</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="نام و نام خانوادگی, کدملی,..."
              type="text"
              class="d-inline-block"
              id="search"
              @input="searchForTurn"
            />
          </b-col>
          <b-col sm="2" class="mb-md-0">
            <b-form-group
              label="انتخاب پزشک"
              label-for="chooseDoctor"
            >
              <my-v-select
                id="chooseDoctor"
                v-model="doctorSelected"
                :multiple="false"
                :options="doctorOptions.length ? doctorOptions : []"
                :translate="false"
                :searchable="true"
                :filterable="true"
                :clearable="true"
              />
            </b-form-group>
          </b-col>
          <b-col xl="2" md="3" cols="12" sm="6">
            <b-form-group class="mb-0">
              <label for="start-date">از تاریخ</label>
              <my-ab-date-picker
                :ref="startDate ? startDate.toString() : 'start-date'"
                :type="'date'"
                :locale="'fa,en'"
                click-on="all"
                clearable
                :show="false"
                :auto-submit="true"
                :isShortcut="true"
                :column="1"
                v-model="startDate"
                :toIso="true"
                :custom-hour="23"
                id="start-date"
              >
              </my-ab-date-picker>
            </b-form-group>
          </b-col>
          <b-col xl="2" md="3" cols="12" sm="6">
            <b-form-group class="mb-0">
              <label for="end-date">تا تاریخ</label>
              <my-ab-date-picker
                :ref="endDate ? endDate.toString() : 'end-date'"
                :type="'date'"
                :locale="'fa,en'"
                click-on="all"
                :isShortcut="true"
                clearable
                :show="false"
                :auto-submit="true"
                :column="1"
                v-model="endDate"
                :toIso="true"
                :custom-hour="23"
                id="end-date"
              >
              </my-ab-date-picker>
            </b-form-group>
          </b-col>
          <b-col md="2" sm="6" xl="2" class="mt-1">
            <b-form-group
              :label="$t('user.turnStatus')"
            > 
              <b-form-select
                 v-model="isDeleted"
                :key="isDeleted"
                :multiple="false"
                :options="isDeletedOption"
                :filterable="true"
                :searchable="true"
                @input="isDeletedValue"

              />
            </b-form-group>
          </b-col>
          <b-col md="2" sm="6" xl="2" class="mt-1">
            <b-form-group
              :label="$t('user.ReferralStatus')"
            >
            
            <b-form-select
                v-model="isCome"
                :key="isComeOption"
                :multiple="false"
                :options="isComeOption"
                :filterable="true"
                :searchable="true"
                @input="isComeValue"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </div>
    <div class="w-100 d-flex justify-content-end mb-1">
      <v-btn tag="button" class="btn btn-success btn-add ml-auto" @click="searchForTurn()"
        >{{ $t("general.search") }}
      </v-btn>
    </div>
    <!-- table -->
    <div class="users-table user-table">
      <vue-good-table
        v-if="data"
        :columns="columns"
        :rows="data"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
          mode: 'pages',
        }"
      >
        <template slot="table-column" slot-scope="props">
          <span class="text-nowrap">
            {{ calcColumnName(props.column.label) }}
          </span>
        </template>

        <!-- Slot: Table Row -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'name'" class="text-nowrap">
            <span v-if="props.row.turnUserId"
              >{{ props.row.turnUserId.firstName }}
              {{ props.row.turnUserId.lastName }}</span
            >
          </span>

          <span v-if="props.column.field === 'nationalCode'" class="text-nowrap">
            <span v-if="props.row.turnUserId">
              <span > <span v-if="props.row.turnUserId.countryId && props.row.turnUserId.countryId[0].en === 'Iran'">{{ props.row.turnUserId.nationalCode }} / </span><span v-if="props.row.turnUserId.countryId && props.row.turnUserId.countryId[0].fa">{{ props.row.turnUserId.countryId[0].fa }}</span></span>

            </span>
          </span>

          <span v-if="props.column.field === 'mobile'" class="text-nowrap">
            <span v-if="props.row.turnUserId">
              {{ props.row.turnUserId.mobile }}
            </span>
          </span>

          <span v-if="props.column.field === 'mydate'" class="text-nowrap">
            <span v-if="props.row.date">{{ dateToPersian(props.row.date) }}</span>
            &nbsp;&nbsp;_&nbsp;&nbsp;
            <span v-if="props.row.endTime">{{ props.row.endTime }}</span> -
            <span v-if="props.row.fromTime">{{ props.row.fromTime }}</span>
          </span>

          <span v-if="props.column.field === 'drName'" class="text-nowrap">
            <span v-if="props.row.planUserId"
              >{{ props.row.planUserId.firstName }}
              {{ props.row.planUserId.lastName }}</span
            >
          </span>
          <span v-if="props.column.field === 'unit'" class="text-nowrap">
               <div  v-for="(unit, index) in unitTurn" :key="index">
                  <span v-if="props.row.unitId === unit._id">
                    {{ unit.title }}
                  </span>
               </div>
          </span>
          <span v-if="props.column.field === 'appointmentStatus'" class="text-nowrap">
            <span
              v-if="!props.row.isDeleted"
              class="badge badge-info"
              >نوبت گرفته شده</span
            >
            <span v-if="props.row.isDeleted === true && !props.row.updatedMoveAt" class="badge badge-danger">
              حذف شده</span
            >
            <span v-else-if="props.row.updatedMoveAt" class="badge badge-warning">
              انتقال داده شده</span
            >
            <!-- <span v-if="del">saa</span> -->
          </span>
          <span v-if="props.column.field === 'ReferralStatus'" class="text-nowrap">
            <span v-if="props.row.isCome === true" class="badge badge-success"
              >مراجعه شده</span
            >
            <span v-if="props.row.isCome === false" class="badge badge-warning"
              >مراجعه نشده</span
            >
          </span>
          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
               
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="props.row.isDeleted != true"
                  @click="getTurnInfo(props.row)"
                >
                  <feather-icon icon="CreditCardIcon" class="mr-50" />
                  <span>{{ $t("general.print") }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row.isDeleted != true && props.row.isToday == true"
                  :disabled="
                    !$ability.can('update', 'users') && !$ability.can('read', 'superuser')
                  "
                  @click="removeQueue(props.row)"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>{{ $t("general.delete") }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row.isDeleted != true && props.row.isToday == false && props.row.isPastTime == true"
                  :disabled="
                    !$ability.can('update', 'users') && !$ability.can('read', 'superuser')
                  "
                  @click="removeQueue(props.row)"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>{{ $t("general.delete") }}</span>
                </b-dropdown-item>
                <b-dropdown-item
                @click="showHistory(props.row)"
                >
                  <feather-icon icon="SearchIcon" class="mr-50" />
                  <span>{{ $t("general.History") }}</span>
                </b-dropdown-item>
                <b-form-checkbox
                :checked="props.row.isCome"
                class="checkIsCome"
                v-if="props.row.isDeleted != true && props.row.isToday == true"
                @change="changeIsCome(props.row)"
                >
                <span> مراجعه شده</span>
                <!-- <span v-if="props.row.isCome=== false"> مراجعه نشده</span> -->
                </b-form-checkbox>
                <b-form-checkbox
                :checked="props.row.isCome"
                class="checkIsCome"
                v-if="props.row.isDeleted != true && props.row.isToday == false && props.row.isPastTime == true"
                @change="changeIsCome(props.row)"
                >
                <span> مراجعه شده</span>
                <!-- <span v-if="props.row.isCome=== false"> مراجعه نشده</span> -->
                </b-form-checkbox>
              </b-dropdown>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">
                {{ $t("pagination.pageLength") }}
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['20', '50', '100']"
                class="mx-1"
                @change="handlePageChange"
              />
              <span class="text-nowrap">
                {{ $t("general.of") }} {{ total }}
                {{ $t("general.pageText2") }}
              </span>
            </div>
            <div>
              <b-pagination
                v-model="page"
                :total-rows="total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="handlePageChange"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
      <div class="modal modalhistory" tabindex="-1" v-if="showModalDrag">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title"> تاریخچه نوبت بیمار "{{ PatientName }}" </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="closeModalHistory">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <vue-good-table
                :columns="columnsHistory"
                :rows="dataH"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'date'" class="text-nowrap">
                    <span v-if="props.row.updatedMoveAt">
                      <div v-for="(item, index) in dataH" :key="index">
                        <span v-if="item._id === props.row._id" class="text-nowrap">
                          {{ formatJalaliDateUpdated(item.updatedMoveAt) }}
                        </span>
                      </div>
                    </span>
                    <span v-if="props.row.createdAt && !props.row.updatedMoveAt">
                      <div v-for="(item, index) in dataH" :key="index">
                        <span v-if="item._id === props.row._id" class="text-nowrap">
                          {{ formatJalaliDateCreated(item.createdAt) }}
                        </span>
                      </div>
                    </span>

                  </span>
                  <span v-if="props.column.field === 'dateTurn'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ formatJalaliDate(item.date) }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'timeTurn'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.endTime }} - {{ item.fromTime }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'nameDr'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.planUserId.firstName }}  {{ item.planUserId.lastName }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'unit'" class="text-nowrap">
                    <div  v-for="(unit, index) in dataH" :key="index">
                      <span v-if="unit._id === props.row._id" class="text-nowrap">
                        <span>{{ unit.unitId.title }} </span>
                      </span>
                    </div>
                  </span>
                  <span v-if="props.column.field === 'user'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.createdUserId.firstName }} {{ item.createdUserId.lastName }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'action'" class="text-nowrap">
                    <span
                      v-if="!props.row.isDeleted && !props.row.updatedMoveAt && !isComeT"
                      class="badge badge-success"
                      >نوبت گرفته شده / مراجعه شده</span
                    >
                    <span
                      v-if="!props.row.isDeleted && !props.row.updatedMoveAt && isComeT "
                      class="badge badge-info"
                      >نوبت گرفته شده </span
                    >
                    <span v-if="props.row.isDeleted === true && !props.row.updatedMoveAt" class="badge badge-danger">
                      حذف شده</span
                    >
                    <span v-else-if="props.row.updatedMoveAt" class="badge badge-warning">
                      انتقال داده شده</span
                    >
                    <!-- <span v-if="del">saa</span> -->
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
</div>
    </div>
    <Print
      v-if="showPrintTurn"
      :reserveFromTime="reserveFromTime"
      :reserveDate="reserveDate"
      :userName="userName"
      :doctorInfoProps="doctorInfoProps"
      :doctorInfo="doctorInfo"
      :unitId="unitId"
      @close="showPrintTurn = false"
    />
  </div>
</template>

<script>
import filterRoles from "@/mixins/filterRoles";
import dateFormat from "@/mixins/dateFormat";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import moment from "jalali-moment";
import { VueGoodTable } from "vue-good-table";
import Print from "@/components/modal/PrintTurn.vue";
import MyVSelect from "@/components/wrapper/select/MyVSelect";

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  mixins: [filterRoles, dateFormat],
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BCardBody,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    MyAbDatePicker,
    Print,
    MyVSelect
  },
  props: ["timeId" , "doctors", "isComeStatus"],
  data() {
    return {
      pageLength: 100,
      data: null,
      searchTerm: "",
      page: 1,
      startDate: null,
      endDate: null,
      showPrintTurn: false,
      userName: "",
      reserveFromTime: "",
      reserveDate: "",
      doctorInfo: "",
      doctorInfoProps: {},
      nationalCode: "",
      response: null,
      dataTurnUserId: null,
      unitId: "",
      isDeleted:null,
      isCome:null,
      doctorSelected:"",
      doctorOptions:[],
      isComeUpdate:false,
      showModalDrag:false,
      PatientName:"",
      userN:"",
      fromTimeH:'',
      endTimeH:"",
      dateH:'',
      DrName:'',
      dataH:[],
      isComeT:true,
      unitTurn:[],
      isDeletedOption:[
        { text:"همه نوبت ها" , value:null},
        { text:"ثبت شده" , value:false},
        { text:"حذف شده" , value:true},
      ],
      isComeOption:[
        {text:"همه مراجعه ها" , value:null},
        {text:"مراجعه شده" , value:true},
        {text:"مراجعه نشده" , value:false},
      ],
      columns: [
        {
          label: "family",
          field: "name",
        },
        {
          label: "nationalCodeN",
          field: "nationalCode",
        },
        {
          label: "mobile",
          field: "mobile",
        },
        {
          label: "date",
          field: "mydate",
        },
        {
          label: "drName",
          field: "drName",
        },
          {
          label: "unit",
          field: "unit",
        },
        {
          label: "turnStatus",
          field: "appointmentStatus",
        },
        {
          label: "ReferralStatus",
          field: "ReferralStatus",
        },
        {
          label: "action",
          field: "action",
        },
      ],
      columnsHistory: [
        {
          label: "تاریخ",
          field: "date",
        },
        {
          label: "تاریخ نوبت",
          field: "dateTurn",
        },
        {
          label: "زمان نوبت",
          field: "timeTurn",
        },
        {
          label: " نام پزشک",
          field: "nameDr",
        },
        {
          label: "واحد",
          field: "unit",
        },
        {
          label: " عملیات",
          field: "action",
        },
        {
          label: " کاربر",
          field: "user",
        },
 
      ]
    };
  },
  computed:{
    ...mapGetters({
      roles: "roles",
      units: "units/units",
    }),
  },
  methods: {
    async searchForTurn() {
     setTimeout(() => { 
          if (!this.startDate) {
            this.startDate = moment(new Date())
              .subtract(0, "days")
              .format("YYYY-MM-DD")
              .toLocaleString("en-GB", { timeZone: "UTC" });
          }
          if (!this.endDate) {
            this.endDate = moment(new Date())
              .add(0, "days")
              .format("YYYY-MM-DD")
              .toLocaleString("en-GB", { timeZone: "UTC" });
          }

          if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
          }
          this.$store.commit("SET_IS_LOADING", true);
          this.typingTimeout = setTimeout(() => {
            const endDate = moment(this.endDate).startOf("day");
            const fromDate = moment(this.startDate).startOf("day");

            const formattedFromDate = `${fromDate.format("YYYY-MM-DD")}T00:00:00.000Z`;
            const formattedEndDate = `${endDate.format("YYYY-MM-DD")}T00:00:00.000Z`;
            const payload = {
              fromDate: formattedFromDate,
              endDate: formattedEndDate,
              keywordForDoctor:this.doctorSelected ? this.doctorSelected : "",
              keywordForPatient: this.searchTerm,
              isComeForPatient:this.isCome,
              isDeletedForPatient:this.isDeleted,
              page: parseInt(this.page),
              limit:parseInt(this.pageLength),
            };
            this.$store.dispatch("plan/searchForTurn", payload).then((res) => {
            this.pageLength = payload.limit
              this.$store.commit("SET_IS_LOADING", false);
              this.data = res.data;
              this.total = res.total;
              if(res.data.length != 0){
                this.getTurnInfo();
              }
              else{
                this.$bvToast.toast('متاسفانه بیماری با این مشخصات پیدا نشد', {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
              }
            })
            .catch((err) => {
              this.$store.commit("SET_IS_LOADING", false);
            });
          }, 1000);
        }, 300);
        this.getTurnInfo();
    },
    isDeletedValue(value){
      this.isDeleted=value
    },
    isComeValue(value) {
      this.isCome= value

    },
    showHistory(row) {   
      this.$store.commit("SET_IS_LOADING", true);
      const payload = {
        planDetailId: row.planDetailId,
        timeId: row.timeId,
        turnOfTimePlanDetailId: row.turnOfTimePlanDetailId
      };
      
      this.$store.dispatch("plan/turnHistory", payload).then((res) => {   
        this.$store.commit("SET_IS_LOADING", false);
        // this.total = res.total;
        this.dataH = res; 
        this.PatientName = row.turnUserId.firstName + " " + row.turnUserId.lastName;
        this.showModalDrag = true;

      });

    },
    formatJalaliDate(date) {
      const jalaliDate = moment(date, 'YYYY-M-D').locale('fa').format('jD/jMMMM/jYYYY');
      return jalaliDate;
    },
    formatJalaliDateCreated(date) {
      const jalaliDate = moment(date, 'YYYY-M-D').locale('fa').format('jD/jMMMM/jYYYY');
      return jalaliDate;
    },
    formatJalaliDateUpdated(date) {
      const jalaliDate = moment(date, 'YYYY-M-D').locale('fa').format('jD/jMMMM/jYYYY');
      return jalaliDate;
    },
    closeModalHistory(){
      this.showModalDrag=false
    },
    async changeIsCome(row) {
      this.$store.commit("SET_IS_LOADING", true);
      const payload = {
        timeId: row.timeId,
        planDetailId: row.planDetailId,
        turnOfTimePlanDetailId: row._id,
        isCome: !row.isCome,
      };     
      this.$store
        .dispatch("plan/updateForCome", payload)
        .then((res) => {

          this.$emit("newReserveData", res);
          this.$emit("closeM");
          this.$store.commit("SET_IS_LOADING", false);
          row.isCome = !row.isCome
          if(row.isCome === true){
            this.isComeT= false
          }
          if(row.isCome === false){
            this.isComeT= true
          }
          })
        .catch((error) => {
          this.$store.commit("SET_IS_LOADING", false);
          let msg = "";
          switch (error.response.status) {
            case 422:
              msg = this.$t("toastification.deletionFailed");
              break;

            case 404:
              msg = this.$t("toastification.deletionFailed");
              break;

            case 400:
              msg = this.$t("toastification.badRequest");
              break;
          }

          this.$bvToast.toast(msg, {
            title: this.$t("toastification.error"),
            variant: "danger",
            solid: true,
          });
        });
    },
    async removeQueue(row) {
      this.$bvModal
        .msgBoxConfirm(this.$t("general.confirmDelete"), {
          title: this.$t("general.confirmDeleteTitle"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("general.yes"),
          cancelTitle: this.$t("general.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$store.commit("SET_IS_LOADING", true);
            const payload = {
              timeId: row.timeId,
              planDetailId: row.planDetailId,
              turnId: row._id,
            };
            this.$store
              .dispatch("plan/deleteTurnOfPlan", payload)
              .then((res) => {
                this.$bvToast.toast(this.$t("toastification.deletionSucceed"), {
                  title: this.$t("toastification.success"),
                  variant: "success",
                  solid: true,
                });
                row.isDeleted = true;
                this.$store.commit("SET_IS_LOADING", false);
              })
              .catch((error) => {
                let msg = "";
                this.$store.commit("SET_IS_LOADING", false);
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
                this.$store.commit("SET_IS_LOADING", false);
              });
          }
        })
        .catch((err) => {
          // alert("error");
          this.$store.commit("SET_IS_LOADING", false);
        });
    },
    async getTurnInfo(row) {
      const payload = {
        timeId: row.timeId,
        planDetailId: row.planDetailId,
        turnOfTimePlanDetailId: row.turnOfTimePlanDetailId,
      };
      this.$store.dispatch("plan/getTurnInfo", payload).then((res) => {
        this.doctorInfoProps = res;
        this.userName =
          this.doctorInfoProps.turnUserId.firstName +
          " " +
          this.doctorInfoProps.turnUserId.lastName;
        this.doctorInfo =
          this.doctorInfoProps.planUserId.firstName +
          " " +
          this.doctorInfoProps.planUserId.lastName;
        this.unitId = this.doctorInfoProps.unitId.title;
        this.reserveFromTime = this.doctorInfoProps.fromTime;
        const date = moment(this.doctorInfoProps.date, "YYYY-MM-DD");
        const formattedDate = date.format("jYYYY-jMM-jDD");
        this.reserveDate = formattedDate;
      });
      this.showPrintTurn = true;
    },
    calcColumnName(col) {
      switch (col) {
        case "action":
          return this.$t("general.action");
        case "date":
          return "تاریخ و ساعت رزرو";
        case "drName":
          return "نام پزشک";
        case "status":
          return "وضعیت";
        default:
          return this.$t(`user.${col}`);
      }
    },
    handlePageChange() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  watch: {
    pageLength() {
      this.page=1
      this.searchForTurn();
    },
    page(){
      this.searchForTurn();
    }
  },
  async created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "AppointmentOfPatients", to: { name: "manageUsers" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "AppointmentOfPatients", to: { name: "usersList" }, translate: true },
    ]);

    this.searchForTurn();
    const payload={
        page:1,
        roleTitle:"doctor"
      }
    this.$store.dispatch("user/searchUsers", payload).then((res) => {
        if(res && res != undefined ){
          const drNames = [...res];
          for(let i = 0;i< drNames.length;i++){
                this.doctorOptions.push({
                  _id: drNames[i]._id, title: `${drNames[i].firstName.toLowerCase()} ${drNames[i].lastName.toLowerCase()}`
                })
            }
        }
      });
      this.$store.dispatch("units/searchUnit", {
      status:"active",
    }).then(res => this.unitTurn=res);
  },
};
</script>

<style scoped>
.checkIsCome{
  margin-left: 18px;
  margin: 0.65rem 0;
  font-size: 1rem;
  color: #6e6b7b !important;
}
</style>
